import React, { Suspense, useEffect } from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import { PreLoading } from "components/Loaders";
import Header from "./Header";
import Footer from "./Footer";
import SystemServices from "services/System";
import { ErrorToaster } from "components/Toaster";
import Storage from "utils/Storage";
import Cookies from "js-cookie";
import { app } from "config/firebase.config";
import { getMessaging, getToken, isSupported } from "firebase/messaging"; // ✅ use "firebase/messaging" not "@firebase/messaging"

const LazyLoading = () => (
  <Box
    sx={{
      display: "block",
      position: "relative",
      justifyContent: "center",
      alignItems: "center",
      minHeight: 380,
      height: "100vh",
    }}
  >
    <PreLoading />
  </Box>
);

function WebsiteLayout() {
  const { setStorageItem } = Storage();

  // ✅ Session ID
  const generateSessionId = async () => {
    try {
      const { data } = await SystemServices.generateSessionID();
      setStorageItem("sessionId", data.sessionid);
      const savedSecSession = Cookies.get("secsession");
      Cookies.set("testCookie", savedSecSession);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // ✅ Firebase Messaging Token
  const generateToken = async () => {
    try {
      const supported = await isSupported();

      if (!supported) {
        console.warn("🔥 Firebase messaging is not supported in this browser.");
        return;
      }

      const messaging = getMessaging(app);

      const currentToken = await getToken(messaging, {
        vapidKey:
          "BClgiPeWLUu2Q_oz822G-rRo_HDzjuh3aKanrZlMHWPDeEnjg4-1FLU65E0WD2L283FzL7R9hxjdM8XZRUrFcrE",
        serviceWorkerRegistration: await navigator.serviceWorker.ready, // ✅ ensures SW is ready
      });

      if (currentToken) {
        localStorage.setItem("fcmToken", currentToken);
        console.log("✅ FCM Token generated:", currentToken);
      } else {
        console.warn("⚠️ No registration token available. Request permission.");
      }
    } catch (err) {
      console.error("❌ Error while retrieving FCM token:", err);
    }
  };

  useEffect(() => {
    generateSessionId();
    generateToken();
  }, []);

  return (
    <Box>
      <Suspense fallback={<LazyLoading />}>
        <Header />
        <Box component="main" sx={{ overflow: "hidden" }}>
          <Outlet />
        </Box>
        {/* <Footer /> */}
      </Suspense>
    </Box>
  );
}

export default WebsiteLayout;
